export default __webpack_public_path__ + "static/media/2.9afbe8df.png";